module.exports = __webpack_public_path__ + "static/img/role.646f1ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/tsz/role.png
// module id = AoRH
// module chunks = 7